import { useFormik } from "formik";
import { programacionInitialValues } from "../constants/constants";
import { ProgramacionForm } from "./programacion.form";
import { useProgramacion } from "../hooks/useProgramacion";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { programacionValidationSchema } from "../constants/validations";

const initialValues = programacionInitialValues;
const validationSchema = programacionValidationSchema;

export const EditarProgramacion = ({ onSave, id_programacion, onCancel }) => {
  const { retriveProgramacion, patchProgramacion } = useProgramacion();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    console.log(values);
    try {
      setIsLoading(true);
      await patchProgramacion(id_programacion, values);
      setIsLoading(false);
      Swal.fire({
        icon: "success",
        title: "Programación guardada",
        timer: 1500,
      });
      onSave();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal!",
        text: `Favor de comunicarlo con el equipo de desarrollo: ${error}`,
      });
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleChange,
    setValues,
  } = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    const getProgramacion = async () => {
      try {
        const response = await retriveProgramacion(id_programacion);
        setValues((prevValues) => ({
          ...prevValues,
          ...response,
        }));
      } catch (error) {
        console.error(error);
      }
    };
    getProgramacion();
  }, [id_programacion, retriveProgramacion, setValues]);

  return (
    <ProgramacionForm
      values={values}
      errors={errors}
      touched={touched}
      setFieldValue={setFieldValue}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      isLoading={isLoading}
      onCancel={onCancel}
    />
  );
};
